import React from 'react'
import { useMediaQuery } from '@material-ui/core'
import { Dialog } from '@progress/kendo-react-dialogs'

import { ButtonHLPure } from '../../pures'

/**
 * @author Marissa Vargas
 * @description - Dialog to handle two actions.
 * @param {string} dialogTitle - Heading
 * @param {string} dialogDescription - Description
 * @param {function} primaryAction - Function triggered when clicking the primary button.  
 * @param {string} primaryBtnText - Primary button text
 * @param {function} secondaryAction - Function triggered when clicking the secondary button.
 * @param {string} secondaryBtnText - Secondary button text
 * @param {function} setCloseDialog - Toggle function to close the dialog.
 * @returns {JSX.element}
 */
function DialogTwoActions({
  dialogTitle,
  dialogDescription,
  primaryAction,
  primaryBtnText,
  secondaryAction,
  secondaryBtnText,
  setCloseDialog,
}) {
  const matches = useMediaQuery('(max-width:820px)')

  return (
    <Dialog
      className='dialogYesNoHLPure-container dialogYesNoHLPure-container-grid'
      title={dialogTitle}
      onClose={setCloseDialog}
      width={matches ? 100 : 290}
      height={matches ? 150 : 300}
    >
      <p>{dialogDescription}</p>
      <div className='dialogYesNoHLPure-btns-container'>
        <div className='dialogYesNoHLPure-btnCancel'>
          <ButtonHLPure
            nameBtn={secondaryBtnText}
            onClickBtn={secondaryAction}
            primary={false}
          />
        </div>
        <ButtonHLPure
          nameBtn={primaryBtnText}
          onClickBtn={primaryAction}
          primary={true}
        />
      </div>
    </Dialog>
  )
}

export default DialogTwoActions
